<template>
  <div>
    <v-card>
      <v-card-title>
        <v-btn
        color="success"
        :disabled="!selectedList.length"
        @click="bulkGenerateCSV"
        class="ml-2"
      >
        <v-icon left>mdi-file-csv</v-icon>
        Export CSV
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!selectedList.length"
        @click="bulkGenerateExcel"
        class="ml-2"
      >
        <v-icon left>mdi-file-excel</v-icon>
        Export Excel
      </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="role.owner || isDevOrEngineer"
          color="primary" 
          dark 
          @click="syncNs"
        >
          Sync Data
        </v-btn>
      </v-card-title>    <v-card-actions class="py-2">
      <v-spacer></v-spacer>
      
    </v-card-actions>

    <v-simple-table>      <thead>
        <tr>
          <th>
            <v-checkbox
              :input-value="selectedAll"
              @change="clickSelectedAll($event)"
              color="#6ec39b"
              class="ma-0 pa-0"
              hide-details
            />
          </th>
          <th>No.</th>
          <th class="order-by-row" @click="changeOrderBy('assetCode')">
            Asset Code
            <v-icon v-if="orderBySelect.key === 'assetCode'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th>
          <th class="order-by-row" @click="changeOrderBy('assetName')">
            Asset Name
            <v-icon v-if="orderBySelect.key === 'assetName'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th>
          <th class="order-by-row" @click="changeOrderBy('assetDepartment')">
            Department
            <v-icon v-if="orderBySelect.key === 'assetDepartment'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th>
          <th class="order-by-row" @click="changeOrderBy('assetLocation')">
            Location
            <v-icon v-if="orderBySelect.key === 'assetLocation'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th>
          <!-- <th class="order-by-row" @click="changeOrderBy('assetClass')">
            Class
            <v-icon v-if="orderBySelect.key === 'assetClass'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th> -->
          <th >
            Last Count Date
           
          </th>
          <th class="order-by-row" @click="changeOrderBy('countStatus')">
            Count Status
            <v-icon v-if="orderBySelect.key === 'countStatus'" small>
              {{ orderBySelect.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
            </v-icon>
          </th>
          <!-- <th class="order-by-row"  >
            Image
            
          </th> -->
          <th>QR Code</th>
          <th>Link</th>
        </tr>
      </thead>
      <tbody>        <tr v-if="!filteredData.length">
          <td :colspan="11" class="text-center py-8">ไม่พบเอกสารที่ต้องการ</td>
        </tr>
        <tr
          v-for="(item, idx) in filteredData"
          :key="item.assetCode"
        >
          <td>
            <v-checkbox
              :input-value="isChecked(item.assetCode)"
              @change="toggleSelect(item)"
              color="#6ec39b"
              class="ma-0 pa-0"
              hide-details
            />
          </td>
          <td>{{ startIndex + idx + 1 }}</td>
          <td>{{ item.assetCode }}</td>
          <td>{{ item.assetName }}</td>
          <td>{{ item.assetDepartment }}</td>
          <td>{{ item.assetLocation }}</td>
          <!-- <td>{{ item.assetClass }}</td> -->
          <td>{{ formatDate(item.lastCountDate) }}</td>          <td>
            <v-chip 
             v-if="item.countStatus"
              small 
              :color="getCountStatusColor(item.countStatus)"
            > 
              {{ item.countStatus }}
            </v-chip>
            <p v-else >status not found</p>
          </td>
          <!-- <td>
            <v-btn 
              v-if="item.imageUrl" 
              icon 
              small 
              color="primary" 
              @click="showImageDialog(item)"
            >
              <v-icon>mdi-image</v-icon>
            </v-btn>
            <v-icon v-else small color="grey">mdi-image-off</v-icon>
          </td> -->
          <td>
            <v-btn icon small color="primary" @click="showQrDialog(item)">
              <v-icon>mdi-qrcode</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn icon small :href="item.link ? item.link : 'about:blank'" target="_blank"  rel="noopener">
              <v-icon :color="item.link ? 'primary' : 'grey'">mdi-link</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    

    <!-- QR Code Dialog -->
   <v-dialog v-model="qrDialog.show" max-width="600">
      <v-card>
        <v-card-title class="headline grey--text">
          Asset QR Code
        </v-card-title>
        <v-card-text class="d-flex align-left py-4">
          <qrcode-vue
            ref="qrCodeRef"
            :value="qrDialog.assetCode"
            :size="100"
            class="my-4"
            v-if="qrDialog.show"
          />
          <div class="text-left ml-4 mt-4">
            <div><strong>Asset Code:</strong> {{ qrDialog.assetCode }}</div>
            <div v-if="qrDialog.assetName"><strong>Name:</strong> {{ qrDialog.assetName }}</div>
            <div v-if="qrDialog.assetType"><strong>Type:</strong> {{ qrDialog.assetType }}</div>
            <div v-if="qrDialog.assetLocation"><strong>Location:</strong> {{ qrDialog.assetLocation }}</div>
            <div v-if="qrDialog.serialNumber"><strong>Serial:</strong> {{ qrDialog.serialNumber }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <!-- <v-spacer></v-spacer>
          <v-btn color="primary" @click="downloadQr(qrDialog.assetCode)">
            Download PNG
          </v-btn>
          <v-btn color="primary" @click="downloadCustomQr(qrDialog.assetCode)">
            Download Custom PNG
          </v-btn>  -->
          <v-btn text @click="qrDialog.show = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Dialog -->
    <v-dialog v-model="imageDialog.show" max-width="800">
      <v-card>
        <v-card-title class="headline grey--text">
          Asset Image
        </v-card-title>
        <v-card-text class="text-center py-4">
          <div class="mb-4">
            <div><strong>Asset Code:</strong> {{ imageDialog.assetCode }}</div>
            <div v-if="imageDialog.assetName"><strong>Name:</strong> {{ imageDialog.assetName }}</div>
          </div>
          <v-img
            v-if="imageDialog.imageUrl"
            :src="imageDialog.imageUrl"
            max-height="400"
            max-width="600"
            contain
            class="mx-auto"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey">mdi-image-off</v-icon>
            <div class="mt-2 grey--text">No image available</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            v-if="imageDialog.imageUrl" 
            color="primary" 
            @click="downloadImage(imageDialog.imageUrl, imageDialog.assetCode)"
          >
            <v-icon left>mdi-download</v-icon>
            Download
          </v-btn>
          <v-btn text @click="imageDialog.show = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-card>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import * as XLSX from 'xlsx'
import { mapState } from "vuex"
import getRole from "@/libs/getRole"

export default {
  name: "AssetTable",
  components: { QrcodeVue },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      selectedAll: false,
      selectedList: [],
      qrDialog: { show: false, assetCode: '' },
      imageDialog: { show: false, assetCode: '', assetName: '', imageUrl: '' },
    }
  },
    computed: {
    ...mapState({
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
    }),
    
    // Role checking
    role() {
      const userCompany = this.userCompany || {};
      return {
        owner: this.checkRole(userCompany) === "owner" && !userCompany?.isDeveloper,
        developer: this.checkRole(userCompany) === "developer",
        engineer: this.user?.isEngineer,
        admin: userCompany?.isAdmin,
        user: this.checkRole(userCompany) === "user"
      };
    },
    
    // Developer or Engineer
    isDevOrEngineer() {
      return this.role.developer || this.role.engineer;
    },
    
    filteredData() {
      if (!Array.isArray(this.data)) {
        return []
      }
      return this.data
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    orderBySelect() {
      return this.$store.state.fixedAssets?.assetListOrderBy || { key: 'assetCode', value: 'desc' };
    },
  },
  watch: {
    selectedList() {
      this.selectedAll = this.selectedList.length === this.filteredData.length && this.filteredData.length > 0
    },
    orderBySelect: {
      handler(newOrderBy, oldOrderBy) {
        if (newOrderBy && oldOrderBy &&
            (newOrderBy.key !== oldOrderBy.key || newOrderBy.value !== oldOrderBy.value)) {
          console.log('OrderBy changed in component:', newOrderBy)
        }
      },
      deep: true
    }
  },
  methods: {
    // Role checking method
    checkRole(userCompany) {
      return getRole(userCompany);
    },
    
    syncNs() {
      this.$emit('syncNs')
    },
    isChecked(assetCode) {
      return this.selectedList.find(x => x.assetCode === assetCode)
    },
    toggleSelect(item) {
      const idx = this.selectedList.findIndex(x => x.assetCode === item.assetCode)
      if (idx === -1) this.selectedList.push(item)
      else this.selectedList.splice(idx, 1)
    },
    clickSelectedAll(checked) {
      if (checked) {
        this.selectedList = [...this.filteredData]
      } else {
        this.selectedList = []
      }
    },    showQrDialog(item) {
        this.qrDialog = {
          show: true,
          assetCode: item.assetCode,
          assetName: item.assetName,
          assetType: item.assetType,
          assetLocation: item.assetLocation, 
          // ...เพิ่มตาม schema ที่คุณมี
        }
    },
    showImageDialog(item) {
      this.imageDialog = {
        show: true,
        assetCode: item.assetCode,
        assetName: item.assetName,
        imageUrl: item.imageUrl
      }
    },
    downloadImage(imageUrl, assetCode) {
      try {
        // Create a temporary link element to download the image
        const link = document.createElement('a')
        link.href = imageUrl
        link.download = `${assetCode}_image.jpg`
        link.target = '_blank'
        
        // Try to download directly first
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
      } catch (error) {
        console.error('Error downloading image:', error)
        // Fallback: open in new tab
        window.open(imageUrl, '_blank')
      }
    },
      downloadQr(assetCode) {
      // ดึง canvas element จาก qrcode-vue แล้วแปลงเป็น PNG
      this.$nextTick(() => {
        const qr = this.$refs.qrCodeRef
        if (qr && qr.$el) {
          const canvas = qr.$el.querySelector('canvas')
          const url = canvas.toDataURL('image/png')
          const link = document.createElement('a')
          link.href = url
          link.download = `${assetCode}_qr.png`
          link.click()
        }
      })
    },
    downloadCustomQr(assetCode) {
    // 1. เอา canvas จาก qrcode.vue
    this.$nextTick(() => {
      const qr = this.$refs.qrCodeRef;
      if (qr && qr.$el) {
        const qrCanvas = qr.$el.querySelector('canvas');
        const size = qrCanvas.width;

        // 2. สร้าง canvas ใหม่
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size + 40; // เพิ่มที่ไว้สำหรับข้อความด้านล่าง

        const ctx = canvas.getContext('2d');
        // 3. วาดพื้นหลังขาว
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 4. วาด QR เดิมลงไป (ตรงกลาง)
        ctx.drawImage(qrCanvas, 0, 0);

        // 5. (Optional) วาดโลโก้ตรงกลาง QR (ถ้ามี)
        // const logo = new Image();
        // logo.src = 'logo.png';
        // logo.onload = () => {
        //   ctx.drawImage(logo, size/2 - 24, size/2 - 24, 48, 48);
        //   // ...ดาวน์โหลดตามข้อ 7
        // };

        // 6. วาดข้อความ
        ctx.font = "16px 'Sarabun', sans-serif";
        ctx.fillStyle = "#333";
        ctx.textAlign = "center";
        ctx.fillText(assetCode, size / 2, size + 30);

        // 7. Export เป็น PNG
        const url = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download = `${assetCode}_qr_custom.png`;
        link.click();
      }
    });
  },    changeOrderBy(order) {
      let orderBy = { ...this.orderBySelect }

      if (orderBy.key !== order) {
        // Different column clicked, start with ascending
        orderBy = { key: order, value: 'asc' }
      } else {
        // Same column clicked, toggle between asc and desc
        orderBy.value = orderBy.value === 'asc' ? 'desc' : 'asc'
      }

      // Update store with proper format
      this.$store.dispatch('fixedAssets/setAssetListOrderBy', {
        orderBy: orderBy,
      })

      console.log('Order changed:', orderBy)

      // Refetch data with new ordering
      const companyId = this.$route.params.companyId || localStorage.getItem('companyId')
      if (companyId) {
        this.$store.dispatch('fixedAssets/fetchAssetList', {
          companyId: companyId,
        })
      } else {
        console.error('Company ID not found for refetching asset list')
      }
    },
    bulkGenerateCSV() {
      try {
        if (!this.selectedList.length) {
          alert('Please select at least one asset to export')
          return
        }

        // Create CSV headers
        const headers = ['Asset Code', 'Asset Name', 'Location', 'Date']
        const currentDate = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD format

        // Create CSV rows
        const csvData = this.selectedList.map(item => [
          item.assetCode || '',
          item.assetName || '',
          item.assetLocation || '',
          currentDate
        ])

        // Combine headers and data
        const csvContent = [headers, ...csvData]
          .map(row => row.map(field => `"${field}"`).join(','))
          .join('\n')

        // Create and download the file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        
        link.setAttribute('href', url)
        link.setAttribute('download', `fixed_assets_export_${new Date().getTime()}.csv`)
        link.style.visibility = 'hidden'
        
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // Clean up the URL object
        URL.revokeObjectURL(url)
          console.log(`Exported ${this.selectedList.length} assets to CSV`)
        } catch (error) {
          console.error('Error generating CSV:', error)
          alert('An error occurred while generating the CSV file. Please try again.')
        }
      
    },
    bulkGenerateExcel() {
      try {
        if (!this.selectedList.length) {
          alert('Please select at least one asset to export')
          return
        }

        // Create Excel data with specified columns
        const excelData = this.selectedList.map((item, index) => {
          return {
            'No.': index + 1,
            'Asset Code': item.assetCode || '',
            'Asset Name': item.assetName || '',
            'Department': item.assetDepartment || '',
            'Location': item.assetLocation || '',
            // 'Class': item.assetClass || '',
            'Last Count Date': this.formatDate(item.lastCountDate) || '',
            'Count Status': item.countStatus || ''
          }
        })

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.json_to_sheet(excelData)

        // Set column widths for better readability
        const columnWidths = [
          { wch: 5 },  // No.
          { wch: 15 }, // Asset Code
          { wch: 30 }, // Asset Name
          { wch: 20 }, // Department
          { wch: 20 }, // Location
          // { wch: 15 }, // Class
          { wch: 15 }, // Last Count Date
          { wch: 12 }  // Count Status
        ]
        worksheet['!cols'] = columnWidths

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Fixed Assets')

        // Generate filename with timestamp
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
        const filename = `fixed_assets_export_${timestamp}.xlsx`

        // Write and download the file
        XLSX.writeFile(workbook, filename)
        
        console.log(`Exported ${this.selectedList.length} assets to Excel`)
        
      } catch (error) {
        console.error('Error generating Excel:', error)
        alert('An error occurred while generating the Excel file. Please try again.')
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '' 
      // Handle Firebase Timestamp object
      if (timestamp && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      }
      
      // Handle regular date string or Date object
      const date = new Date(timestamp)
      return date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long', 
      day: 'numeric'
      })
    },

    getCountStatusColor(countStatus) {
      if (countStatus === 'Counted' || countStatus === 'counted') return 'success'
      if (countStatus === 'Uncounted' || countStatus === 'uncounted') return 'warning'
      if (countStatus === 'Missing' || countStatus === 'missing') return 'error'
      if (countStatus === 'New') return 'info'
      return 'grey'
    }
  }
}
</script>

<style scoped>
.order-by-row {
  cursor: pointer;
}

.order-by-row:hover {
  background-color: #f5f5f5;
}

.qr-modal-canvas {
  margin: auto;
  display: block;
}
</style>
